import { type ElementType, type ReactNode } from 'react';

import { Divider, Flex, IconProps } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';

import { isMobileView } from 'constants/isMobileView';

import { TextHeader3 } from 'uiToolkitV1/Typography';

interface Props {
  Icon?: ElementType<IconProps>;
  heading: string;
  children?: ReactNode;
  hasDivider?: boolean;
  testId?: string;
}

const CardTemplate = ({ Icon, heading, children, hasDivider = true, testId }: Props) => {
  const hasIcon = !!Icon;

  return (
    <Card
      style={{
        width: '100%',
        marginTop: '16px',
        padding: '0px 12px',
      }}
      data-testid={testId}
    >
      <CardContent>
        <Flex p="12px 12px" alignItems="center">
          {hasIcon && <Icon mr="8px" boxSize="24px" fill="transparent" color="#333333" />}
          <TextHeader3 paddingLeft="7px" bold>
            {heading}
          </TextHeader3>
        </Flex>
        {hasDivider && <Divider opacity={1} color="#EBEFF3" />}

        {children}
      </CardContent>
    </Card>
  );
};

export { CardTemplate };
